//import * as d3 from 'd3'
import Chart from '../chart'

import './PeopleChart.css'

export default class PeopleChart extends Chart {
  create() {
    this.svg = super.createRoot();
    this.main = this.svg.append('g')
      .attr('class', 'main');

    this.legend = this.main.append('g')
      .attr('class', 'legend');

    const defs = this.svg.append('defs');
    defs.append('filter')
      .attr('id','foreignerFilter')
      .append('feColorMatrix')
      .attr('in', 'SourceGraphic')
      .attr('type', 'matrix')
      .attr('values',`-1 0 0 0 1 
        0 -1 0 0 1 
        0 0 -1 0 1
        0 0 0 1 0`
      );
    defs.append('filter')
      .attr('id','newBelgianFilter')
      .append('feColorMatrix')
      .attr('in', 'SourceGraphic')
      .attr('type', 'matrix')
      .attr('values',`-1 0 0 0 0.2 
        0 -1 0 0 0.2 
        0 0 -1 0 0.2
        0 0 0 1 0`
      );
  }

  // Main D3 rendering, that should be redone when the data updates.
  update(state) {
    if (JSON.stringify(state) !== JSON.stringify(this.state)) {
      this.intl = state.intl;
      this.drawPeople(state);
      this.drawLegend(state);
    }
  }

  drawPeople(state) {
    const center = { x: this.props.width / 2, y: this.props.height / 2 };
    const size = 0.55 * Math.min(this.props.width, this.props.height)

    const theta = Math.PI * (3 - Math.sqrt(5));
    const data = Array(120).fill(1).map((_, i) => {
      const radius = size/20 * Math.sqrt(i);
      const angle = i * theta;
      const x = radius * Math.cos(angle);
      const y = radius * Math.sin(angle);
      const height = size/5
      return { 
        index: i, 
        x,
        y,
        height,
        image: `${(i % 32) + 1 }.png`,
      }
    })
    .sort((a, b) => a.x < b.x ? -1 : 1)
    .map((d, i) => ({...d, type: i < 52 ? 'belgian' : (i < 78 ? 'newBelgian' : 'foreigner') }))
    .sort((a, b) => a.y < b.y ? -1 : 1);

    this.people = this.main.selectAll('.people')
      .data(data, d => d.index);

    this.people.exit()
      .transition()
      .duration(1000)
      .style('opacity', 0)
      .remove();

    var peopleEnter = this.people.enter()
      .append('svg:image')
      .attr('class', 'people')
      .attr('filter', d => this.getFilter(d.type, state))
      .attr('x', d => center.x)
      .attr('y', d => center.y)
      .attr('width', 0)
      .attr('height', 0)
      //.style('opacity', 0)
      .attr('xlink:href', d => {
        if(d.image) {
          try {
            const img = require(`../../../assets/images/people/${d.image}`);
            return img;
          } catch (ex) {
            return '';
          }
        }
        return '';
      });

    this.people
      .merge(peopleEnter)
      .transition()
      .duration(1500)
      .attr('x', d => center.x + d.x - (d.height/2))
      .attr('y', d => center.y + d.y - (d.height/2))
      .attr('width', d => d.height)
      .attr('height', d => d.height)
      .attr('filter', d => this.getFilter(d.type, state))
      .style('opacity', 1) 
  }

  getFilter(type, state) {
    if (state.step >= 7 && type === 'newBelgian') {
      return 'url(#newBelgianFilter)'
    } else if(state.step >= 6 && (type === 'foreigner' || type === 'newBelgian')) {
      return 'url(#foreignerFilter)'
    } 
    return ''
  }

  drawLegend(state) {
    const pos = { x: 3 * this.props.width / 4, y: this.props.height / 3 };
    const size = 0.8 * Math.min(this.props.width, this.props.height)
    const height = size/12

    this.legend.selectAll('*').remove()

    const legendBelgian = this.legend.append('g')
      .attr('opacity', state.step >= 5 ? 1 : 0)
    const legendForeigner = this.legend.append('g')
      .attr('opacity', state.step >= 6 ? 1 : 0)
    const legendNewBelgian = this.legend.append('g')
      .attr('opacity', state.step >= 7 ? 1 : 0)

    legendBelgian
      .append('svg:image')
      .attr('class', 'imageLegend')
      .attr('x', pos.x - (height*0.7))
      .attr('y', pos.y - (height*0.7))
      .attr('width', height)
      .attr('height', height)
      .attr('xlink:href', require(`../../../assets/images/people/12.png`));

    legendBelgian
      .append('text')
      .attr('class', 'textLegend')
      .attr('y', pos.y - (height*.5))
      .attr('font-size', 14)
      .attr('dominant-baseline', 'middle')
      .attr('text-anchor', 'start')
      .attr('textShadow', 'none')
      .attr('stroke-width', 0)
      .attr('fill', 'black')
      /*.append('tspan')
      .text('One silhouette represents')
      .attr('x', pos.x + (height/2))*/
      .append('tspan')
      .text(`= 10,000 ${this.intl.formatMessage({ id: 'app.people2'})}`)
      .attr('x', pos.x + (height*0.25))
      .attr('dy', 20)

    /*legendBelgian.transition()
      .duration(1000)
      .delay(2000)
      .attr('opacity', 1)*/

    legendForeigner
      .append('text')
      .attr('x', pos.x - (0.7*height))
      .attr('y', pos.y - (height))
      .attr('font-size', 18)
      .attr('dominant-baseline', 'middle')
      .attr('text-anchor', 'start')
      .attr('textShadow', 'none')
      .attr('font-weight', 'bold')
      .attr('fill', 'black')
      .text(this.intl.formatMessage({ id: 'app.people1'}))

    legendForeigner
      .append('text')
      .attr('x', pos.x - (0.7*height))
      .attr('y', pos.y + (height*0.7))
      .attr('font-size', 18)
      .attr('dominant-baseline', 'middle')
      .attr('text-anchor', 'start')
      .attr('textShadow', 'none')
      .attr('font-weight', 'bold')
      .attr('fill', 'black')
      .text(this.intl.formatMessage({ id: 'app.people3'}))

    legendForeigner
      .append('svg:image')
      .attr('class', 'imageLegend')
      .attr('x', pos.x - (height*0.7))
      .attr('y', pos.y + (1.1*height))
      .attr('width', height)
      .attr('height', height)
      .attr('filter', 'url(#foreignerFilter)')
      .attr('xlink:href', require(`../../../assets/images/people/12.png`));

    legendForeigner
      .append('text')
      .attr('class', 'textLegend')
      .attr('y', pos.y + (1.2*height))
      .attr('font-size', 14)
      .attr('dominant-baseline', 'middle')
      .attr('text-anchor', 'start')
      .attr('textShadow', 'none')
      .attr('stroke-width', 0)
      .attr('fill', 'black')
      /*.append('tspan')
      .text('One silhouette represents')
      .attr('x', pos.x + (height/2))*/
      .append('tspan')
      .text(`= 10,000 ${this.intl.formatMessage({ id: 'app.people4'})}`)
      .attr('x', pos.x + (height*0.35))
      .attr('dy', 20)

    legendNewBelgian
      .append('svg:image')
      .attr('class', 'imageLegend')
      .attr('x', pos.x - (height*0.7))
      .attr('y', pos.y + (2*1.2*height))
      .attr('width', height)
      .attr('height', height)
      .attr('filter', 'url(#newBelgianFilter)')
      .attr('xlink:href', require(`../../../assets/images/people/12.png`));

    legendNewBelgian
      .append('text')
      .attr('class', 'textLegend')
      .attr('y', pos.y + (2*1.3*height))
      .attr('font-size', 14)
      .attr('dominant-baseline', 'middle')
      .attr('text-anchor', 'start')
      .attr('textShadow', 'none')
      .attr('stroke-width', 0)
      .attr('fill', 'black')
      /*.append('tspan')
      .text('One silhouette represents')
      .attr('x', pos.x + (height/2))*/
      .append('tspan')
      .text(`= 10,000 ${this.intl.formatMessage({ id: 'app.people5'})}`)
      .attr('x', pos.x + (height*0.35))
      .attr('dy', 20)
  }
}


